import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class GoogleAnalyticsCommunicatorService {
  private addGoogleAnalyticEventSubject = new Subject<any>();

  public addGoogleAnalyticEvent$ = this.addGoogleAnalyticEventSubject.asObservable();

  addGoogleAnalyticEvent(event: any) {
    this.addGoogleAnalyticEventSubject.next(event);
  }
}
